import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import FooterNew from "../Components/FooterNew";
import QuickLinks from "./QuickLinks";
import FeeList from "./FeeList";

const Fee = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;

  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div>
        <div className="Main-Header-Container">
          <section
            className="py-xxl-10 pb-0"
            id="home"
            style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
          >
            <div
              className="bg-holder"
              style={{
                backgroundImage: `url(${heroBgImage})`,
                backgroundPosition: "bottom",
                backgroundSize: "cover",

                //   height: "100vh", // Add a height to ensure background is visible
              }}
            />

            <div className="container">
              <div className="row min-vh-xl-100 min-vh-xxl-25">
                <div className=" paddin-header   text-center ">
                  <h2 className="">
                    <span
                      className=" general-tittle-mbl"
                      style={{
                        fontSize: "48px",
                        fontFamily: "Raleway, sanf-serif",
                        color: "#fff",
                        paddingBottom: " 10px",
                      }}
                    >
                      Consultation Fee
                    </span>
                  </h2>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div>
        <FeeList />
      </div>

      {/* <div
        className=" about-summary-inline  "
        style={{
          marginTop: "80px",
          background: "#ededed",
          borderLeft: "5px solid #03b1ed",
          padding: "5px 20px 0px",
          marginBottom: "120px",
        }}
      >
        <p>
          These charges are for self paying patients. Please be aware that
          charges will vary between insurance companies for patients who are
          covered.
          <ol
            className="row text-center"
            style={{
              listStyleType: "disc",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              lineHeight: "60px",
              marginLeft: "20px",
              fontSize: "18px",
              fontWeight: "550",
              letterSpacing: ".225px",
              fontFamily: "Open Sans sans-serif",
            }}
          >
            <li
              className="  col-lg-6 col-md-6 col-sm-12"
              style={{
                textAlign: "start",
                fontWeight: "bolder",
                fontSize: "18px",
                listStyleType: "disc",
              }}
            >
              Initial Consultation £ 220
            </li>
            <li
              className="  col-lg-6 col-md-6 col-sm-12"
              style={{
                textAlign: "start",
                fontWeight: "bolder",
                fontSize: "18px",
                listStyleType: "disc",
              }}
            >
              Follow up Consultation £ 120
            </li>
          </ol>
          <p style={{ marginTop: "-20px" }}>
            Cost of surgical and non surgical procedures vary greatly according
            to the type of procedure, time taken, equipment required and
            complexity. Before the procedure is planned, Dr Ahmed can give a
            more accurate cost prior based on the above factors.
          </p>
        </p>
      </div> */}

      <div className="footer-import footer-import-contact mt-5">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default Fee;
